import Vue from 'vue';
import Accordion from 'primevue/accordion';

Vue.component('Accordion', Accordion);
